import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class FormationComponentService {
    // Observable sources
    private formationChangedSource = new Subject<number>();

    // Observable sources
    private formationChangedFc = new Subject<boolean>();

    // Observable string streams
    formationChanged$ = this.formationChangedSource.asObservable();

    // Observable string streams
    fcChanged$ = this.formationChangedFc.asObservable();

    // When a formation is updated
    changeFormation(formationId: number) {
        this.formationChangedSource.next(formationId);
    }

    // When a formation continue is updated
    changeFc(fc: boolean) {
        this.formationChangedFc.next(fc);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/formationComponent.service.ts